<div appDragDropFile [ngClass]="{'another-file-over-class': hasAnotherDropZoneOver}"
    (fileOver)="fileOverAnother($event)" 
    (fileDropped)="dropped($event)"
    class="font-medium-1 grey my-drop-zone round">
    <div class="py-5 md-2 text-center" *ngIf="!resourcesList || resourcesList.length == 0">
        <div>Drop your files here
            
        </div>   
        <i class="ft-image" style="font-size:'2rem'"></i>
    </div>

    <div class="grid-hover" >
        <div class="row ms-3">
            <div class="" *ngFor="let item of previews">
                <div *ngIf="item.type == 'PHOTO'">
                    <figure  class="effect-ruby round">
                        <img [hidden]="loading" [src]="item.fileReader" alt="img"
                        height="185px"
                        width="200px"
                        style="padding-left: 0.5em"/>
                        <button
                            type="button"
                            class="close-file ft-x-circle"
                            aria-label="Close"
                            (click)="removeResource(item)"
                          >
                        </button>
                    </figure>
                </div> 
            </div>
        </div>
    </div>




    
</div>


<!--div *ngIf="resourcesList && resourcesList.length > 0"
    class="col"
    >
    <div
    *ngFor="let file of resourcesList; let i = index"
    class="row border m-2"
    >
        <div *ngIf="file.type == 'PDF'">
            <a href="" (click)="openFile(file.url)">{{
            file.file ? file.file.name : file.url
            }}</a>
            <i
            class="bi bi-x-square ms-5"
            type="button"
            pbutton
            (click)="removeResource(file)"
            ></i>
        </div>
    </div>
</!--div>
<div-- *ngIf="resourcesList && resourcesList.length > 0">
    <div
    *ngFor="let file of resourcesList; let i = index"
    class="col"
    >
        <div *ngIf="file.type == 'AUDIO'" class="row border m-2">
            <a href="" (click)="openFile(file.url)">{{
            file.file ? file.file.name : file.url
            }}</a>
            <i
            class="bi bi-x-square ms-5"
            type="button"
            pbutton
            (click)="removeResource(file)"
            ></i>
        </div>
    </div>
</div-->

<!--div class="embed-responsive embed-responsive-16by9 w-25 h-50 p-3">
    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0" allowfullscreen></iframe>
</!--div>

<div!-- class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div!-->

<!--img src="https://d2fiw2ombiemc7.cloudfront.net/multisite/statics/examples/img-product-7.png" alt="img"/-->
